import React from 'react';
import { connect } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';

function DashboardRedirectContainer({ currentWorkspaceId, me }) {
  const { workspaceId } = useParams();

  if (workspaceId) {
    return <Redirect to={`/w/${workspaceId}/dashboard`} />;
  }

  if (currentWorkspaceId) {
    return <Redirect to={`/w/${currentWorkspaceId}/dashboard`} />;
  }

  if (!me) {
    return null;
  }

  // identity.me is normalized, so workspaces and accounts hold ids
  if (me.workspaces?.length > 0) {
    return <Redirect to={`/w/${me.workspaces[0]}/dashboard`} />;
  }

  if (me.accounts?.length > 0) {
    return <Redirect to={`/a/${me.accounts[0]}`} />;
  }

  return <Redirect to="/no-home" />;
}

export default connect(({ currentWorkspaceId, identity: { me } }) => {
  return { currentWorkspaceId, me };
}, {})(DashboardRedirectContainer);
